import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { configSlice } from './slices/config';
import { singlaRSlice } from './slices/signalr';
import { authSlice } from './slices/auth';
import { ordersSlice } from './slices/orders';
import { notificationsSlice } from './slices/notifications';
import { InitialConfig } from '../types/types.config';
import { UserState } from '../types/types.user';
import { OrdersGlobal } from '../types/types.orders';
import { CompleteNotification } from '../types/types.notifications';
import { SignalRStates } from '../types/types.system';
import { resetSlice } from './slices/resetSlice';
import { dashboardsSlice } from './slices/dashboards';
import { DashBoardState } from '../types/types.dashboard';
import { QuotationsState } from '../types/types.facturacion';
import { quotationSlice } from './slices/quotations';
import { appointmentsSlice } from './slices/appointments'
import { preorderSlice } from './slices/preorders'
import { AppointmentsState } from '../types/types.agendaCitas';
import { PreOrderState } from '../types/types.preorders';
import { errorMiddleware } from './errorMiddleware';
import { createAction } from '@reduxjs/toolkit';

type ConfigState = InitialConfig;

interface RootState {
  configuration: ConfigState;
  userInfo: UserState;
  globalOrders: OrdersGlobal;
  notifications: CompleteNotification;
  signalR: SignalRStates;
  reset: any;
  dashboards: DashBoardState;
  globalQuotation: QuotationsState;
  globalAppointments: AppointmentsState;
  globalPreOrder: PreOrderState;
}

const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = (state: RootState | undefined, action: any) => {
  if (action.type === 'reset/resetState') {
    storage.removeItem('persist:root'); // limpia localStorage
    state = undefined; // reinicia todos los estados
  }
  return combineReducers({
    configuration: configSlice.reducer,
    userInfo: authSlice.reducer,
    globalOrders: ordersSlice.reducer,
    notifications: notificationsSlice.reducer,
    signalR: singlaRSlice.reducer,
    reset: resetSlice.reducer,
    dashboards: dashboardsSlice.reducer,
    globalQuotation: quotationSlice.reducer,
    globalAppointments: appointmentsSlice.reducer,
    globalPreOrder: preorderSlice.reducer,
  })(state, action);
};


const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER'],
        // También puedes ignorar valores específicos del estado si es necesario
        ignoredPaths: ['some.nested.path'],
      },
    }).concat(errorMiddleware),
    devTools: process.env.NODE_ENV === 'development',
});

const persistor = persistStore(store);

export type RootStateP = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const resetState = createAction('reset/resetState');

export { store, persistor };
